import { createCompanyQuery } from 'util/createCompanyQuery';

import { CompanyApi } from 'api/CompanyApi';
import { CompanyModel, mapCompanyDtoToModel } from 'api/dto/Company.dto';
import { mapProjectDtoToModel, ProjectModel } from 'api/dto/Project.dto';

export class CompanyRepository {
  constructor(private companyApi: CompanyApi) {}

  list(): Promise<CompanyModel[]> {
    const query = createCompanyQuery();

    return this.companyApi.getList(query).then((list = []) => {
      return list.map(mapCompanyDtoToModel);
    });
  }

  projectList(query: string): Promise<ProjectModel[]> {
    return this.companyApi
      .getProjectList(query)
      .then((result) => result._embedded.items.map((entry) => mapProjectDtoToModel(entry)));
  }

  updateEnabledLanguages(id: number, languages: string[]): Promise<CompanyApi.EnabledLocales> {
    return this.companyApi.updateEnabledLanguages(id, languages);
  }

  updateEnabledDashboardLanguages({
    id,
    languages,
    enableDashboardLanguages,
    translateComments,
  }: {
    id: number;
    languages: string[];
    enableDashboardLanguages: boolean;
    translateComments: boolean;
  }): Promise<CompanyApi.EnabledLocales> {
    return this.companyApi.updateEnabledDashboardLanguages(
      id,
      languages,
      enableDashboardLanguages,
      translateComments,
    );
  }

  getProfile(companyId: number): Promise<CompanyApi.CompanyProfile> {
    return this.companyApi.getProfile(companyId);
  }

  updateProfile(companyId: number, profile: CompanyApi.CompanyProfile): Promise<void> {
    return this.companyApi.updateProfile(companyId, profile);
  }

  createMergeLinkToken(companyId: number): Promise<string> {
    return this.companyApi.createMergeLinkToken(companyId);
  }

  createMergeConnection(companyId: number, publicToken: string): Promise<void> {
    return this.companyApi.createMergeConnection(companyId, publicToken);
  }

  getMergeConnections(companyId: number): Promise<CompanyApi.MergeConnection[]> {
    return this.companyApi.getMergeConnections(companyId);
  }

  getHrisDemographyCustomFields(
    connectionId: string,
  ): Promise<CompanyApi.HrisDemographyCustomField[]> {
    return this.companyApi.getHrisDemographyCustomFields(connectionId);
  }

  getHrisDemographyCustomFieldMappings(
    connectionId: string,
  ): Promise<CompanyApi.HrisDemographyCustomFieldMapping[]> {
    return this.companyApi.getHrisDemographyCustomFieldMappings(connectionId);
  }

  saveHrisDemographyCustomFieldMappings(
    connectionId: string,
    mappings: CompanyApi.SaveHrisDemographyCustomFieldMapping[],
  ): Promise<void> {
    return this.companyApi.saveHrisDemographyCustomFieldMappings(connectionId, mappings);
  }
}
